<template>
  <div class="confetti-checkbox">
    <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
    <label class="confetti-checkbox-label">
      <input
        class="confetti-checkbox-input"
        type="checkbox"
        :checked="checked"
        :disabled="disabled"
        @change="$emit('change', $event.target.checked)"
      />
      <div class="confetti-checkbox-checkmark-container">
        <div class="confetti-checkbox-checkmark"></div>
      </div>
      <span class="confetti-checkbox-text">{{ label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: "ConfettiCheckbox",
  model: {
    prop: "checked",
    event: "change",
  },
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    label: {
      type: String,
      required: true,
    },
  },
};
</script>
